import { render, staticRenderFns } from "./CarHealthExportModal.vue?vue&type=template&id=24c5d47c&"
import script from "./CarHealthExportModal.vue?vue&type=script&lang=ts&"
export * from "./CarHealthExportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports